import React, { useRef } from 'react'
import { Toast } from 'primereact/toast'

interface PopUpProviderProps {
  children?: React.ReactNode
}

export type PopUpContextType = {
  openPopup: (_:PopUpConfig) => void
}

export const PopupContext = React.createContext<PopUpContextType>({ 'openPopup':(_) => {} })

type PopUpConfig = {
  title?: string
  text?: string
  severity?: 'info' | 'success' | 'warn' | 'error'
  sticky?: boolean
  duration?: number
}
export const PopupProvider = ({ children }:PopUpProviderProps) => {
  const openPopup = (config:PopUpConfig) => {
    toast.current?.show({
      severity: config.severity || 'info',
      summary: config.title || 'Under Construction',
      detail: config.text || 'We know you are finding your match... but first, we need to find our missing code! 🛠❤️',
      sticky: config.sticky || false,
      life: config.duration || 3000,
    })
  }

  const toast = useRef<Toast>(null)

  return (
    <PopupContext.Provider value={{ openPopup }}>
      {children}
      <Toast ref={toast} position="top-right" onRemove={() => {}}/>
    </PopupContext.Provider>
  )
}
